import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthenticatedUser } from './AuthenticatedUser';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthenticationService {

	private _authenticatedUser: AuthenticatedUser = null;

	constructor(
		private cookieService: CookieService,
		private readonly http: HttpClient) {

		const token = this.cookieService.get("access_token");
		if (token) {
			try {
				this.authenticatedUser = new AuthenticatedUser(token);
			} catch (e) {
				this.authenticatedUser = null;
			}
		}
	}

	logOut() {
		this.authenticatedUser = null;
		this.cookieService.delete("access_token");
	}

	async logIn(username: string, password: string) {
		var response = await this.http.post("/api/auth/token", { username: username, password: password }).toPromise();
		const token = response["token"];
		console.log("received token: " + token);
		this.authenticatedUser = new AuthenticatedUser(token);
		this.cookieService.set('access_token', token, 10);
	}


	private popupCenter(url, title, w, h): Window {
		// Fixes dual-screen position
		let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : (<any>screen).left;
		let dualScreenTop = window.screenTop != undefined ? window.screenTop : (<any>screen).top;

		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		var left = ((width / 2) - (w / 2)) + dualScreenLeft;
		var top = ((height / 2) - (h / 2)) + dualScreenTop;
		var newWindow = window.open(url, title, 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

		// Puts focus on the newWindow
		if (window.focus) {
			newWindow.focus();
		}

		return newWindow;
	}


	get accessToken() {
		return this.authenticatedUser ? this._authenticatedUser.token : null;
	}

	get decodedAccessToken() {
		return this.authenticatedUser ? this._authenticatedUser.decodedToken : null;
	}

	set authenticatedUser(val: AuthenticatedUser) {
		this._authenticatedUser = val;
	}

	get authenticatedUser(): AuthenticatedUser {
		return this._authenticatedUser;
	}


	checkAccess(role: CoreRoles): boolean {

		if (!!this.authenticatedUser) {
			return this.authenticatedUser.roles.some(x => CoreRoles[x] === role);
		}

		return false;
	}

	//role access

	get administrator() {
		return this.checkAccess(CoreRoles.Administrator);
	}

	get centralContractAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.CentralContract_Read) || this.contractReadWriteAccess;
	}

	get centralContractWriteAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.CentralContract_ReadWrite);
	}


	get contractAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.Contract_Read) || this.contractReadWriteAccess;
	}

	get contractReadWriteAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.Contract_ReadWrite);
	}

	get projectAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.Project_Read) || this.projectWriteAccess;
	}

	get projectWriteAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.Project_ReadWrite);
	}

	get storeWriteAccess() {
		return this.checkAccess(CoreRoles.Administrator) || this.checkAccess(CoreRoles.Store_ReadWrite);
	}

}

export enum CoreRoles {
	Administrator,
	Store_ReadWrite,
	Contract_Read,
	Contract_ReadWrite,
	CentralContract_Read,
	CentralContract_ReadWrite,
	Project_Read,
	Project_ReadWrite
};




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/authentication/authentication.service.ts